const messages = {
  title: "Bonus",
  word: "Bonus",
  description: "Učesnicima se kešbek naknade uknjižavaju na osnovu dostavljenih podataka o prihodima.",
};

export default {
  messages,
};
